import React, { useState, useEffect } from "react";
// Components
import Header2 from "../../mainLayout/Header/Header2";
import HeaderComponent from "../../mainLayout/Header/HeaderComponent";
import StaticPart from "../Dashboard/StaticPart";
import CardServices from "./../Dashboard/CardServices";
// React Bootstrap
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
// React icons
import { BiPhoneCall } from "react-icons/bi";
import AgoraUIKit from "agora-react-uikit";
/* global zugora */
import VideoCall from "../VideoCall/VideoCall";
import { getAllBuses, getAllCities } from "../../../actions/buses";
import { getAllPackages, getAllTrips } from "../../../actions/trips";
import { getAllOperatorsClient } from "../../../actions/operators";
import Swal from 'sweetalert2'
import store from "../../../store";
const BusListing2 = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const status = queryParams.get("status");

    if (status === "verified") {
      Swal.fire({
        icon: "success",
        title: "",
        text: "Great !! Your email address has been verified at BusArabia.com. Let's create journeys for memories !!!",
      });
    }
    if (status == "invalid") {
      Swal.fire({
        icon: "error",
        title: "",
        text: "Invalid or expired link",
      });
    }
  }, []);


  const handleVoiceModal = () => {
    handleShow();
  };
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);
  useEffect(() => {
    store.dispatch(getAllBuses());
    store.dispatch(getAllTrips());
    store.dispatch(getAllPackages());
    store.dispatch(getAllCities());
    store.dispatch(getAllOperatorsClient());
  }, []);


  return (
    <>
      {/* <Header2/> */}
      <div className="topCardServices homePadding">
        {/* <HeaderComponent title={"Book Bus Tickets"}/> */}
        <CardServices />
      </div>
      {/* Voice call Button */}
      {/* <button className="voice-call-demo" onClick={handleShow}>
        <BiPhoneCall color="#fff" fontSize="50px" />
      </button> */}

      <Modal
        show={show}
        onHide={handleClose}
        className="videoModal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>BusArabia Support</Modal.Header>
        <Modal.Body>
          <VideoCall handleClose={handleClose} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BusListing2;
